/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable max-len */
import React, {useState, useContext, useCallback, useEffect} from 'react'
import { motion } from 'framer-motion';
import FilterModal from './FilterModal';
import moment from 'moment'
import { distributorService } from '../../../service/distributor.service';
import HeaderContext from '../../../Components/Context/HeaderContext';
import Pagination from '../../../Components/Pagination';
import EmptyOrderPage from '../../MyOrders/EmptyOrderPage';
import OrderListingSkeleton from '../../MyOrders/OrderListingSkeleton';
import { PriceHandler } from '../../../redux/helper/CamelCase';

const InvoiceReport = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [InvoiceReportList, setInvoiceReportList] = useState([]);
    const [sortType, setsortType] = useState('INVOICE_DATE+desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [totalPage, setTotalPage] = useState('');
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);
    const [filterModal, setFilterModal] = useState(false)
    const [filterUrl, setfilterUrl] = useState('')
    const [Filter, setFilter] = useState({
        order_category:[],
        payment_status:[],
    })
    const [filterValue, setfilterValue] = useState('');
    const [selected, setselected] = useState({
        order_start_date: '',
        order_end_date: '',
        invoice_start_date: '',
        invoice_end_date: '',       
    });
    const [exportClick, setexportClick] = useState(false);
    const [exportSelected, setexportSelected] = useState('');

    const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;

    const handleInvoiceReport = useCallback((() => {
        distributorService.MISInvoiceReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, searchValue, sortType, filterValue,).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setLoading(false);
                setInvoiceReportList(response.data.Items);
                setCurrentPage(response.data.current_page);
                setTotalPage(response.data.number_of_pages);
            } else {
                setLoading(false);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue, exportSelected]);

    const handleExport = useCallback((() => {
        distributorService.MISInvoiceReport(DISTRIBUTOR.ACCOUNT_NUMBER, currentPage, searchValue, sortType, filterValue, exportSelected ).then((response) => {
            if (response.data.success_status) {
                SetSuccessMessage(response.data.message);
                setexportClick(false);
                setexportSelected('');
                window.open(response.data.url, '_blank');
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
            }
        });
    }), [exportSelected]);

    useEffect(() => {
        if (exportSelected !== '') {
            handleExport();
        }
    }, [handleExport]);

    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleFilter = (filterUrl) => {
        if (filterUrl.length > 0 && filterValue !== filterUrl) {
            setLoading(true);
            setCurrentPage(1);
            setfilterValue(filterUrl);
        } else {
            setLoading(false);
            setfilterValue(filterUrl);
        }
    };

    useEffect(() => {
        handleInvoiceReport();
    }, [handleInvoiceReport]);


    return (
        <div className="md:px-[46px] px-4 sm:pt-[30px] pt-3.5">
            {(loading && !emptyData) ? <OrderListingSkeleton /> : (
                <div>
                    <div className="flex items-center justify-between pb-[10px] flex-wrap">
                        <h5 className="sm:text-xs10 text-lg font-semibold text-[#090406] lg:mb-0 mb-3">Invoice Report</h5> 
                        <div className="lg:mb-0 mb-3">
                            <div className="flex sm:mx-2 mx-0 items-center flex-wrap w-full">
                                <button 
                                    type="button" 
                                    className="flex items-center bg-[#F5F5FA] font-bold text-xs text-[#555259] border-2 border-[#E9EDF4] sm:py-2.5 py-1.5 px-5 rounded-[9px]" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#filtermodal"
                                    onClick={() => setFilterModal(true)}
                                >
                                    {filterValue === '' ? '' :<span className='mr-1'><img src="/images/red-button.png"></img></span>}Filter
                                </button>
                                <div className="pl-2 dropdown relative">
                                    <button 
                                        type="button" 
                                        id="exportDropdown" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false" 
                                        className="dropdown-toggle text-xs2 font-semibold text-[#555259] sm:py-2.5 py-1.5 sm:px-4 px-2 border border-[#555259] rounded-lg"
                                        onClick={()=>setexportClick(!exportClick)} 
                                    >
                                        Generate Report
                                    </button>
                                    <ul className={`dropdown-menu sm:min-w-[125px] min-w-[120px] absolute ${exportClick ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[9] sm:p-3.5 p-1.5`} style={{zIndex: '9'}} aria-labelledby="exportDropdown">
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center"  
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('csv')}}
                                            >CSV</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => {
                                                    setexportSelected('pdf-converter')}}
                                            >PDF</a>
                                        </li>
                                        <li className="hover:bg-[#F2F2F3] hover:rounded sm:py-1 py-0.5">
                                            <a 
                                                className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" 
                                                href="#"
                                                onClick={() => setexportSelected('excel')}
                                            >Excel</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="ml-3 relative cursor-pointer">
                                    <input                                         
                                        value={searchValue}
                                        onChange={(e) => {
                                            setsearchValue(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        autoComplete="off" 
                                        type="text" 
                                        className="lg:w-[200px] w-[160px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0" 
                                        placeholder="Search"/>
                                    <img 
                                        src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {InvoiceReportList.length > 0 && (
                            <div className="overflow-auto dropdown-menu pb-7 relative z-[6]" style={{height: 'calc(100vh - 297px)'}}>
                                <table className="w-full table-auto relative">
                                    <thead className='sticky top-0 left-0 z-[2]'>
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-2.5 sm:px-7 px-3 rounded-bl-lg rounded-tl-lg min-w-[136px] bg-[#555259] text-start sticky left-0" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Invoice No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[244px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Invoice Date
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'INVOICE_DATE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'INVOICE_DATE+asc') {
                                                                    setsortType('INVOICE_DATE+desc');
                                                                } else if (sortType === 'INVOICE_DATE+desc') {
                                                                    setsortType('INVOICE_DATE+asc');
                                                                } else {
                                                                    setsortType('INVOICE_DATE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[244px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    E-way Bill No.
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[182px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Category
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[244px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex justify-start items-center">
                                                    Order Date
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'ORDER_DATE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'ORDER_DATE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'ORDER_DATE+asc') {
                                                                    setsortType('ORDER_DATE+desc');
                                                                } else if (sortType === 'ORDER_DATE+desc') {
                                                                    setsortType('ORDER_DATE+asc');
                                                                } else {
                                                                    setsortType('ORDER_DATE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[225px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                    Transporter Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[176px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Indent Number
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[210px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Order Acceptance No. 
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[200px] text-center">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Shipped From 
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[210px] text-center">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Shipped To
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[206px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-start">
                                                    Invoice Value
                                                    <a href="javascript:void(0)" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{ rotate: sortType === 'INVOICE_VALUE+asc' ? 180 : 0 }}
                                                            className={`${sortType === 'INVOICE_VALUE+desc' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                if (sortType === 'INVOICE_VALUE+asc') {
                                                                    setsortType('INVOICE_VALUE+desc');
                                                                } else if (sortType === 'INVOICE_VALUE+desc') {
                                                                    setsortType('INVOICE_VALUE+asc');
                                                                } else {
                                                                    setsortType('INVOICE_VALUE+asc');
                                                                }
                                                                // setCurrentPage(1);
                                                                // setLoading(true);
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-2.5 sm:px-7 px-3 min-w-[180px] text-start">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Payment Status 
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {InvoiceReportList.length > 0 && InvoiceReportList.map((item, idx) => (
                                            <tr key={idx} className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                                <td className="sticky left-0 text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 z-[1]" style={{background:'rgba(255, 255, 255, 0.45)',backdropFilter:'blur(5.5px)'}}>
                                                    {item?.TRX_NUMBER}                     
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.INVOICE_DATE === null ? '-' : moment(item?.INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss')}                   
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.WAYBILL_NUMBER === null ? '-' : item?.WAYBILL_NUMBER }
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_CATEGORY}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {moment(item?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.TRANSPORTER_NAME === null ? '-' : item?.TRANSPORTER_NAME }                    
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.INDENT_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.ORDER_ACCEPTANCE_NUMBER}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-center">
                                                    {item?.SHIP_FROM}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-center">
                                                    {item?.SHIP_TO}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-center">
                                                    {PriceHandler(item?.INVOICE_VALUE)}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 sm:px-7 px-3 text-start">
                                                    {item?.PAYMENT_STATUS === null? 'PENDING' : item?.PAYMENT_STATUS}
                                                </td>
                                            </tr>
                                        ))}
                        
                                    </tbody>
                                </table>
                            </div>
                        )}          
                        {InvoiceReportList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={InvoiceReportList}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                        {filterModal && 
                        <FilterModal 
                            filterModal={filterModal}
                            setFilterModal={setFilterModal}
                            Filter={Filter}
                            setFilter={setFilter}
                            filterUrl={filterUrl}
                            setfilterUrl={setfilterUrl}
                            selected={selected}
                            setselected={setselected}
                            filterValue={filterValue}
                            setfilterValue={setfilterValue}
                            handleInvoiceReport={handleInvoiceReport}
                            InvoiceReportList={InvoiceReportList}
                            handleFilter={handleFilter}
                            SetSuccessMessage={SetSuccessMessage}
                        />}
                    </div>
                    {emptyData && <EmptyOrderPage search="yes" text="no Invoice Report" all={searchValue.length > 0 ? 'under searched term' : 'found'} />}
                </div>
            )}          
        </div>
    )
}

export default InvoiceReport
